import PhoneInput from "react-phone-input-2";
import "../styles/phoneInput.scss";
import { useState } from "react";

const Input = (props: any) => {
  return (
    <PhoneInput
      specialLabel={""}
      country={props.country}
      inputStyle={{
        borderColor: props.touched && props.error && "red",
      }}
      {...props}
    />
  );
};

const PhoneInputCommponent = (
  props: any | { handleChange: any; value: any }
) => {
  const handlePhone = (e: any) => {
    const input = { target: { name: "phone", value: e } };

    props.handleChange(input);
  };

  return (
    <Input
      label={"Mobile Phone"}
      req={true}
      helperText={""}
      error={true}
      name="phone"
      prefix="+"
      onChange={handlePhone}
      isSelect={false}
      country={props.country}
      value={props.value}
      {...props.input}
      {...props.meta}
      {...props.custom}
    />
  );
};

export default PhoneInputCommponent;
